import Slider from '@/external/assorted/Slider';
import { mapGetters } from 'vuex';
import { EventBus } from '@/helpers/event-bus';
import { prevAll } from '@/helpers/utils';

export const SliderMixin = {
    data() {
        return {
            slider: []
        };
    },
    computed: {
        ...mapGetters(['editorMode', 'getCurrentRouteFullPath'])
    },
    methods: {
        reinitializeSliders() {
            new Slider().killWidows();
            let refs = this.$refs.slider;
            if (refs !== undefined && refs !== null) {
                if (!Array.isArray(refs)) {
                    refs = [refs];
                }
                refs.forEach((refs__value, refs__key) => {
                    if (!(refs__key in this.slider)) {
                        this.slider[refs__key] = new Slider();
                    }
                    this.slider[refs__key].init(refs__value);
                });
            }
        }
    },
    props: {},
    watch: {
        module: {
            handler() {
                if (this.editorMode) {
                    this.$nextTick().then(() => {
                        this.reinitializeSliders();
                    });
                }
            },
            deep: true
        },
        /* reinitialize on route change (e.g. when configurator is opened/closed) */
        getCurrentRouteFullPath() {
            if (this.editorMode) {
                this.$nextTick().then(() => {
                    this.reinitializeSliders();
                });
            }
        }
    },
    updated() {
        if (this.editorMode) {
            this.$nextTick().then(() => {
                this.reinitializeSliders();
            });
        }
    },
    mounted() {
        if (this.editorMode) {
            this.reinitializeSliders();
            EventBus.$on('slider-goto', (data) => {
                this.slider.forEach((slider__value) => {
                    if (
                        slider__value.el.querySelector('[data-slide-id="' + data.id + '"]') !== null
                    ) {
                        setTimeout(() => {
                            slider__value.goTo(
                                prevAll(
                                    slider__value.el.querySelector(
                                        '[data-slide-id="' + data.id + '"]'
                                    )
                                ).length
                            );
                        }, 1000);
                    }
                });
            });
        }
    }
};
